// UI texts: the season path (krug 5, K15.2)
export default {
  title: 'Season {n}',
  daysLeft: '{n} days left',
  dayLeft: 'Last day',
  goals: '{done}/{total} goals',
  next: 'Next: {text} · {progress}/{target}',
  allDone: 'Every goal done this season',
  toClaim: '{n} to claim',
  claim: 'Claim',
  claimed: 'Claimed',
  claimedToast: 'Claimed: {what}',
  reward: 'Reward: {what}',
  intro: 'The same goals for everyone. They start over with the next season; what is done and not claimed is paid when it ends.',
  cardAria: 'Season {n}, {days}, {done} of {total} goals. Open the season path.',
  error: 'Could not load the season.',
  action: 'Claim',
  /** 4. 10. 2026 (package 3, B–E). */
  tabs: { path: 'Path', score: 'Score', end: 'Season end', legacy: 'Legacy' },
  crate: {
    title: 'Supply crate',
    body: 'Every {n} daily contracts after the last goal: 100 Scrap, 2 supplies and a 1 in 10 chance of a Rare item.',
    progress: '{n}/{need} dailies toward the next crate',
    open: 'Open a crate',
    ready: '{n} ready',
    got: 'Supply crate: {what}',
  },
  score: {
    title: 'Season Score',
    yours: 'Your points',
    place: '#{n} of {total}',
    percentile: 'top {n}%',
    notYet: 'Not a participant yet: {n} more points.',
    participants: '{n} participants',
    participantsOne: '1 participant',
    participantRule: 'A participant has at least {n} points.',
    top: 'Top 10',
    topLater: 'The top 10 shows once 5 survivors are participants.',
    total: 'Total',
    updated: 'Updated {time}',
    points: '{n} pts',
    you: 'you',
    how: 'How points come',
    rules: {
      goals: '{n} for every season path goal claimed',
      horde: '{a} / {b} / {c} for each horde by the personal threshold you reach',
      pvp: '{n} for a fight won against a real player or their track, at most {max} a day (never on the same IP)',
      secrets: '{n} for finding a secret zone first in the world',
      book: '{n} for every new field in the Collection book this season',
      runs: '{n} for every finished expedition, at most {max} a day',
    },
  },
  end: {
    title: 'Season end',
    when: 'Season {n} ends on {date} at {time}.',
    soonCard: 'Season {n} ends in {days}',
    soonCardHours: 'Season {n} ends in {h} hours',
    cardLink: 'What stays, what resets',
    keeps: 'What stays',
    resets: 'What starts over',
    rewards: 'Rewards by place',
    champion: 'Top {n} (at most 10% of participants): a Legendary outfit of your choice, the title "Season {s} Champion" and its frame.',
    veteran: 'Top 25% of participants: the title "Season {s} Veteran" and its frame.',
    discount: 'At least {n} of {total} path goals: Relic Discount, the first forge next season costs 40 Relic Shards instead of 60.',
    legacyRule: 'Everyone: Legacy points, 1 for every 4 path goals claimed (at most 7 a season).',
    now: 'What you earn so far',
    nowPlace: 'Place',
    nowPoints: 'Points',
    nowGoals: 'Path goals',
    nowLegacy: 'Legacy points',
    nowDiscount: 'Relic Discount',
    yes: 'yes',
    no: 'not yet',
    notParticipant: 'not a participant yet',
    waitingDot: 'Something from the last season waits here',
  },
  flow: {
    over: 'Season {n} is over',
    place: 'You finished #{n} of {total}',
    notParticipant: 'You were not a participant this time.',
    points: '{n} points',
    earned: 'What you earned',
    champion: 'Season {n} Champion: title, frame and a Legendary outfit of your choice',
    veteran: 'Season {n} Veteran: title and frame',
    discount: 'Relic Discount: your first forge this season costs 40 Relic Shards',
    legacy: '{n} Legacy points',
    nothingElse: 'Legacy points: {n}',
    outfit: 'Pick your champion outfit',
    outfitSub: 'Any set, in Legendary. It is yours for good and shows "{label}" in the book and on Appearance.',
    outfitPick: 'Take {name}',
    outfitDone: 'Outfit taken: {name}',
    keep: 'Keep 3 recipes',
    keepSub: 'Pick up to {n} of the recipes you learned. They join your new book in the rarity they had.',
    keepBtn: 'Keep these {n}',
    keepDone: 'Recipes kept',
    background: 'Choose your background',
    backgroundSub: 'Your name and look stay. The background sets your attributes and starting kit.',
    walkOut: 'Walk out',
    walkOutSub: 'Level 1, with your Legacy perks. Choices you skip wait on the Season screen.',
    later: 'Later',
    next: 'Next',
    walked: 'Season {n}: you walk out again.',
    waiting: 'From season {n}',
  },
  legacy: {
    title: 'Legacy perks',
    sub: 'Bought once, they work in every season after. None of them touches combat.',
    points: '{n} Legacy points to spend',
    earned: '{n} earned in all',
    buy: 'Buy · {n}',
    owned: 'Owned',
    bought: 'Legacy perk: {name}',
  },
};
